import { useEffect, useState } from 'react'

type Countdown = {
  hours: string
  minutes: string
  seconds: string
}

const START_SECONDS = 23 * 3600 + 35 * 60 + 14

function pad(value: number): string {
  return value.toString().padStart(2, '0')
}

export function useCountdown(): Countdown {
  const [remaining, setRemaining] = useState<number>(START_SECONDS)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? START_SECONDS : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
